import * as core from '../../../../../../../core'

import { query } from './subaward-risk-score.query'

export const RESOURCE = {
  payload: {
    alias: 'sr.subaward-details.widgets.subaward-risk-score',
    description: 'Subaward Risk Score',
    name: 'Subaward Risk Score',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
